export function fireGTMTrackingEvent(event, override = {}) {

  const tngaDataLayer = window.tngaDataLayer || {};

  const tngaEventTemplate = {
      configuration: override.configuration || tngaDataLayer.configuration || {},
      page: override.page || tngaDataLayer.page || {},
      product: override.product || tngaDataLayer.product || {},
      userinfo: override.userinfo || tngaDataLayer.userinfo || {},
      workflow: override.workflow || tngaDataLayer.workflow || {},
      event: event
  };

  const dataLayerTemplate = {
      event: event.name,
      label: event.label,
      action: event.action
  };

  window.tngaDataLayer = tngaEventTemplate;

  console.log('tngaDataLayer ', window.tngaDataLayer);

  if (Array.isArray(window.dataLayer)) {
    window.dataLayer.push(dataLayerTemplate);
  }
};